import React from 'react';
import Sym from '../components/Sym';

/**
 * Prueba social — REFORMULADA (decisión §4.6/4.7): sin cifras infladas ni
 * testimonios/logos ficticios. Mensaje cualitativo hasta tener referencias
 * reales autorizadas.
 */
const POINTS = [
  { icon: 'apartment', text: 'Empresas de todos los tamaños' },
  { icon: 'verified', text: 'Recibos timbrados, directo del SAT' },
  { icon: 'schedule', text: 'Entrega automática, sin trabajo manual' },
];

const SocialProof2 = () => (
  <section style={{ padding: '40px clamp(20px,5vw,40px)' }}>
    <div style={{ maxWidth: 980, margin: '0 auto', textAlign: 'center' }}>
      <p style={{ font: "600 .82rem 'IBM Plex Mono'", letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--marquee-2)', margin: '0 0 22px' }}>
        Empresas mexicanas que ya dejaron de repartir recibos a mano
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 'clamp(16px,4vw,44px)' }}>
        {POINTS.map((p) => (
          <div key={p.text} style={{ display: 'inline-flex', alignItems: 'center', gap: 9, font: "600 1rem 'Hanken Grotesk'", color: 'var(--body-strong)' }}>
            <Sym name={p.icon} size={20} color="#6FA0FF" />{p.text}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof2;
